import { mapKeys } from 'lodash'
import { v4 as uuidv4 } from 'uuid';
import { PLUGIN_NAME } from "../constants";

/**
 * @param {lender1,lender2} //object
 */

export const constructValues = (lender1, lender2) => {
    const lenders = { lender1, lender2 }
    let index = 1
    //renaming the lender1 & lender2 key, adding space between lender 1 or 2 as space is required in between
    return mapKeys(lenders, function () {
        return `lender ${index++}`;
    });
}

/** Get cookie data based on cookie name.
 * @param  {string} cookieName
 * @returns {string | null} The value of the cookie if found, otherwise null.
 */
export const getCookieData = (cookieName) => {
    const cookiesArray = document.cookie.split(';');

    for (let i = 0; i < cookiesArray.length; i++) {
        const cookie = cookiesArray[i].trim();

        if (cookie.startsWith(cookieName + '=')) {
            return cookie.substring(cookieName.length + 1);
        }
    }
    return null;
};

/** Check if an object is empty.
 * @param {Object} object The object to check.
 * @returns {boolean} True if the object is empty, otherwise false.
 */
export function isEmpty(object) {
    return Object.values(object).some((value) => {
        return value === "";
    });
}

export const mapEnquiryDetails = ({lender1, lender2, postcode}, enquiryData) => {
    const url = window.location.href;
    const pathname = new URL(url).pathname;
    const conversionPage = pathname.replace(/^\/|\/$/g, "");

    const payload = {
        emailData: {
            details: {
                "Postcode": postcode,
            },
            results: {
                lender1,
                lender2
            }
        },
        enquiryData: {
            ...enquiryData,
            pluginName: PLUGIN_NAME,
            leadOriginatingPage: getCookieData("leadOriginatingPage") ?? "",
            conversionPage: conversionPage ? conversionPage : "postcode-calculator",
            campaignId: getCookieData('campaignId') ?? "",
            pageSlug: window.location.pathname ?? "",
            tmpId: uuidv4()
        },
        inputData: { postcode }
    };
    return payload;
};
